import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getStringifiedQueryParams } from 'utils/helpers/fetch';

const oidcStorage = JSON.parse(
  sessionStorage.getItem(
    `oidc.user:${process.env.REACT_APP_AUTH_URL}:${process.env.REACT_APP_IDENTITY_CLIENT_ID}`
  )
);
const auth = `Bearer ${oidcStorage?.access_token}`;

export const tagTypes = [
  'Additive',
  'Customer',
  'Destination',
  'Date',
  'Driver',
  'InventoryOwner',
  'Load',
  'LoadingControl',
  'LoadType',
  'Location',
  'Product',
  'Recipe',
  'Supplier',
  'Terminal',
  'Trailer',
];

const dispatchingApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_DISPATCHING_BASE_URL}/`,
    paramsSerializer: getStringifiedQueryParams,
    prepareHeaders: (headers, { getState }) => {
      const { affiliate } = getState().authentication;
      headers.set('X-CARRIERID', affiliate.customerIdName);
      headers.set('X-MAGELLANID', affiliate.dataCompanyId);
      if (oidcStorage) headers.set('authorization', auth);
      return headers;
    },
  }),
  endpoints: () => ({}),
  reducerPath: 'dispatchingApi',
  refetchOnFocus: false,
  tagTypes,
});

export default dispatchingApi;

export const { usePrefetch } = dispatchingApi;
